import { render, staticRenderFns } from "./HeaderWechatPopover.vue?vue&type=template&id=686af576&scoped=true"
import script from "./HeaderWechatPopover.vue?vue&type=script&lang=js"
export * from "./HeaderWechatPopover.vue?vue&type=script&lang=js"
import style0 from "./HeaderWechatPopover.vue?vue&type=style&index=0&id=686af576&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686af576",
  null
  
)

export default component.exports